import { createApi } from "@reduxjs/toolkit/query/react";
import endpoints, { baseURL } from "data/api/v1/endpoints.ts";
import { baseQueryWithRedirect } from "features/api/utils/apiUtils.ts";
import { UserEmulationResponse, UserEmulationResponseData } from "types/api/users/getUserEmulation.ts";
import { UserDetailsResponseData } from "types/api/users/getUserDetails.ts";

export const userApiSlice = createApi({
	reducerPath: "userApi",
	baseQuery: baseQueryWithRedirect(baseURL),
	endpoints: (builder) => ({
		getUserDetails: builder.query<UserDetailsResponseData, void>({
			query: () => endpoints.users.getUserDetails(),
			transformResponse: (response: any) => response?.data,
			transformErrorResponse: (error: { status: string | number }) => ({
				status: error?.status
			})
		})
	})
});

export const userEmulationApiSlice = createApi({
	reducerPath: "userEmulationApi",
	baseQuery: baseQueryWithRedirect(baseURL),
	endpoints: (builder) => ({
		getUserEmulation: builder.query<UserEmulationResponseData, void>({
			query: () => endpoints.users.getUserEmulation(),
			transformResponse: (response: UserEmulationResponse) => response.data,
			transformErrorResponse: (error: { status: string | number }) => ({
				status: error?.status
			})
		})
	})
});

export const { useGetUserDetailsQuery } = userApiSlice;
export const { useGetUserEmulationQuery } = userEmulationApiSlice;
